import { useEffect } from 'react';
import { setBookingsOrganisationId, useBookingsStore } from './bookingsStore';

const BOOKINGS_REFRESH_INTERVAL_MS = 30_000;

export type { RefetchOptions } from './bookingsStore';

interface UseBookingsResult {
  isLoading: boolean;
  error: string | null;
}

const useBookings = (organisationId: string | undefined): UseBookingsResult => {
  const isLoading = useBookingsStore((state) => state.isLoading);
  const error = useBookingsStore((state) => state.error);
  const refetch = useBookingsStore((state) => state.refetch);

  useEffect(() => {
    setBookingsOrganisationId(organisationId);

    if (!organisationId) return;

    const { hasLoadedOnce } = useBookingsStore.getState();
    void refetch(undefined, { silent: hasLoadedOnce });
  }, [organisationId, refetch]);

  useEffect(() => {
    if (!organisationId) return;

    const intervalId = setInterval(() => {
      void refetch(undefined, { silent: true });
    }, BOOKINGS_REFRESH_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [organisationId, refetch]);

  return {
    isLoading,
    error,
  };
};

export default useBookings;
